import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_REQUEST } from ".";
import {
  toolsTradeAPI,
  fetchAboutAPI,
  fetchPartnerAPI,
  eventCoverageAPI,
  privacyPolicyAPI,
  glossaryTermsAPI,
  fetchTeamLeadersAPI,
  fetchBotDirectoriesAPI,
  getSubscriptionsAPI,
  getCurriculumOverview,
} from "../../routes/apiEndPoints";

export const transformLessonData = (data) => {
  return data?.length > 0
    ? data.map((item) => ({
      ...item,
      title: item?.event_coverage_title ?? "",
      text: item?.event_coverage_description ?? "",
      image: item?.event_coverage_image ?? "",
    }))
    : [];
};

//""fetch-tools-trade""
export const fetchToolsTrade = createAsyncThunk(
  "fetch-tools-trade",
  async () => {
    try {
      const response = await API_REQUEST({
        url: toolsTradeAPI,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

//"fetch-event-coverage"
export const fetchEventCoverage = createAsyncThunk(
  "fetch-event-coverage",
  async () => {
    try {
      const response = await API_REQUEST({
        url: eventCoverageAPI,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

// "fetch-partners"
export const fetchPartners = createAsyncThunk("fetch-partners", async () => {
  try {
    const response = await API_REQUEST({
      url: fetchPartnerAPI,
      method: "GET",
    });
    return response;
  } catch (error) { }
});

//"fetch-team-leaders"
export const fetchTeamLeaders = createAsyncThunk(
  "fetch-team-leaders",
  async () => {
    try {
      const response = await API_REQUEST({
        url: fetchTeamLeadersAPI,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);
//"fetch-about"
export const fetchAbout = createAsyncThunk("fetch-about", async () => {
  try {
    const response = await API_REQUEST({
      url: fetchAboutAPI,
      method: "GET",
    });
    return response;
  } catch (error) { }
});
//"fetch-glossary-terms"
export const fetchGlossaryTerms = createAsyncThunk(
  "fetch-glossary-terms",
  async () => {
    try {
      const response = await API_REQUEST({
        url: glossaryTermsAPI,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

//"fetch-privacy-policy"
export const fetchPrivacyPolicy = createAsyncThunk(
  "fetch-privacy-policy",
  async () => {
    try {
      const response = await API_REQUEST({
        url: privacyPolicyAPI,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

//"fetch-bot-directory"
export const fetchBotDirectory = createAsyncThunk(
  "fetch-bot-directory",
  async () => {
    try {
      const response = await API_REQUEST({
        url: fetchBotDirectoriesAPI,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

// fetch-subscriptions
export const fetchSubscriptions = createAsyncThunk(
  "fetch-subscriptions",
  async () => {
    try {
      const response = await API_REQUEST({
        url: getSubscriptionsAPI,
        method: "GET",
      });
      return response;
    } catch (error) { }
  }
);

//fetch Curriculum overview

export const fetchCirriculumOverview = createAsyncThunk(
  "fetch-curriculum-overview",
  async () => {
    try {
      const response = await API_REQUEST({
        url: getCurriculumOverview,
        method: "GET",
      });
      console.log(response)
      return response;
    } catch (error) { }
  }
);